import request from "../utils/request";

//查询案例列表
export function caseList(data) {
  return request({
    url: `/pc/case/${data}`,
    method: 'get'
  })
}
